import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Post } from '../AxiosFunctions';
import { BaseURL } from '../Config';
import useApi from '../useApis';
import useClinic from './useClinic';
import { useDispatch } from 'react-redux';
import { setPatients, setTotalCount, setSearch } from '../Store/patientSlice';
let doctorClinicId = null;

const usePatient = () => {
  const { patients, totalCount, search } = useSelector((state) => state?.patientListReducer);
  const dispatch = useDispatch();
  const { getAllPatientsQueue, patientsQueue } = useClinic();
  const userData = useSelector((state) => state?.authReducer);
  if (userData?.clinicData?.[0]) doctorClinicId = userData?.clinicData?.[0]?.doctorClinicId ?? 0;
  // const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [existingPatients, setExistingPatients] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  // const [paymentFromPatient, setPaymentFromPatient] = useState(null);
  const api = useApi();
  //This api provides listing of Patients
  const getAllPatientsListing = async (pageNumber = 1, search) => {
    setLoading(true);
    const response = await api?.getAllPatientsListing({
      pageNumber: pageNumber ? pageNumber : 1,
      pageSize: 10,
      totalRowsCount: 0,
      sortField: '',
      sortDirection: '',
      search,
      filter: {
        doctorClinicId: userData?.clinicData[0]?.doctorClinicId
      }
    });
    if (response?.data?.headers?.code === 200) {
      dispatch(setPatients(response?.data?.body?.data?.patients));
      dispatch(setTotalCount(response?.data?.body?.pagination?.totalRowsCount));
      setLoading(false);
      return response?.data?.body;
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  // get All Patients Details
  const getPatientsDetails = async () => {
    setLoading(true);
    const response = await Post(BaseURL(''));
    if (response?.data?.headers?.code === 200) {
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  //search by number our existing patients (integrate in link PateintDrawer)
  const getAllExistingPatients = async (params) => {
    setLoading(true);
    const response = await api?.getAllPatients({ ...params, doctorClinicId });
    if (response?.data?.headers?.code == 200) {
      const transformData = [];
      response?.data?.body?.patients?.forEach((data) => {
        let patientData = null;
        data?.patientsData?.forEach((currentData) => {
          patientData = { cellNumber: data?.cellNumber, ...currentData };
          transformData.push(patientData);
        });
        return patientData;
      });

      setExistingPatients(transformData);
      setTotalCount(response?.data?.body?.pagination?.totalRowsCount);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const linkOrAddPatient = async (params, resetForm) => {
    setLoading(true);
    const response = await api?.linkOrAddPatient({ doctorClinicId, ...params });
    if (response?.data?.headers?.code === 200) {
      // getPa
      getAllPatientsQueue();
      toast.success(
        params?.patientId ? 'Patient add to queue successfully' : 'Patient created successfully'
      );
      if (typeof resetForm === 'function') resetForm();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const editPatient = async (params, resetForm) => {
    const response = await api.editPatientDetail(params);
    if (response?.data?.headers?.code === 200) {
      resetForm();
      toast.success('Patient Edit Successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };
  const getPatientPaymentHistory = async (params, resetForm) => {
    setLoading(true);
    const response = await api.getPatientPaymentHistory(params);
    if (response?.data?.headers?.code === 200) {
      setPaymentDetails(response?.data?.body);
      if (typeof resetForm === 'function') resetForm();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const patientPayment = async (params, resetForm) => {
    setLoading(true);
    const response = await api?.patientPayment(params);
    if (response?.data?.headers?.code === 200) {
      setPaymentDetails(response?.data?.body);
      if (typeof resetForm === 'function') resetForm();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  return {
    loading,
    patients,
    totalCount,
    setPage,
    setTotalCount,
    setPatients,
    page,
    setSearch,
    search,
    getAllPatientsListing,
    existingPatients,
    getPatientsDetails,
    getAllExistingPatients,
    linkOrAddPatient,
    editPatient,
    patientsQueue,
    getAllPatientsQueue,
    setExistingPatients,
    getPatientPaymentHistory,
    paymentDetails,
    setPaymentDetails,
    patientPayment
  };
};

export default usePatient;
